export class CollectorUtil {
    /**
     * 给业务模块提供页面同步率埋点数据
     * 使用示例：
     * import { CollectorUtil } from '@mtfe/metric';
     * window.LXAnalytics('pageView', { custom: CollectorUtil.getMetricReportData() }, environment, cid);
     * 返回示例：
     * {
     *   'metric_collect_custom': {
     *     "258711": "a", // ${layerId} - ab实验策略
     *     "258711_s": "true" //${layerId}_s - ab实验策略对应的开关
     *     "258711_f": "ehc" // ${layerId}_s - ab实验策略对应的来源
     *   }
     * }
     * @return Object 页面同步率埋点数据
     */
    static getMetricReportData() {
        // 兼容SSR场景
        if (typeof window === 'undefined') return {};
        // 从window._PGY_GLOBAL_CONFIG._PGY_WINK_COOKIE中获取页面同步率埋点数据
        const { _PGY_GLOBAL_CONFIG: config = {} } = window;
        const { _PGY_WINK_COOKIE = {}, prefetchInfo = {} } = config;
        const { report = {} } = _PGY_WINK_COOKIE;
        return {
            'metric_collect_custom': {
                ...report,
                ...prefetchInfo
            }
        };
    };
};
